import React, { Component } from 'react';
import { Grid, Button, Typography, IconButton, Icon } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';


import DraggableExpansionPanel from '../../components/dragAndDrop/DraggableExpansionPanel';

import WeekBlock from './scheduleComponents/WeekBlock';

const styles = theme => ({

});

class ModuleSchedule extends Component {

    render() {
        const { classes, alreadySelectedLessons, allLessons, module_id } = this.props

        let relatedLessonIDs = []
        alreadySelectedLessons.forEach(lesson => {
            relatedLessonIDs.push(lesson.lesson_id)
        });

        let draggableLessonItems = allLessons.map((lesson) => {
            if (relatedLessonIDs.includes(lesson.lesson_id)) {
                return (
                    <DraggableExpansionPanel alreadySelected={true} item={lesson} key={lesson.lesson_id} module_id={module_id} onDrop={this.props.dropItemToDay} itemName={lesson.LessonName} expansionInfo={lesson.LessonDescription} base_view={'module_schedule'} />
                )
            }
            return (
                <DraggableExpansionPanel alreadySelected={false} item={lesson} key={lesson.lesson_id} module_id={module_id} onDrop={this.props.dropItemToDay} itemName={lesson.LessonName} expansionInfo={lesson.LessonDescription} base_view={'module_schedule'}/>
            )
        }
        )


        let weekRows = [];
        for (var i = 1; i < Number(this.props.scheduleWeeksNeeded) + 1; i++) {
            weekRows.push(
                (
                    <WeekBlock key={i} week={i} lessons={alreadySelectedLessons} module_id={module_id} view_type={this.props.view_type} />
                )
            )
        }


        return (
            <div>
                <Grid container spacing={24}>
                    <Grid item xs={3}>
                        <Typography>
                            <IconButton
                                onClick={(ev) => {
                                    let removingWeekInfo = this.props.alreadySelectedLessons.filter((lesson) => lesson.WeekNum === this.props.scheduleWeeksNeeded)
                                    if (removingWeekInfo.length > 0) {
                                        if (window.confirm('You will lose information, continue?')) this.props.updateWeeksAmount('DOWN')
                                    }
                                    else {
                                        this.props.updateWeeksAmount('DOWN')
                                    }


                                }}
                                disabled={this.props.scheduleWeeksNeeded === 1}
                            >
                                <Icon>chevron_left</Icon>
                            </IconButton>
                            Weeks Needed: {this.props.scheduleWeeksNeeded}
                            <IconButton
                                onClick={(ev) => {
                                    this.props.updateWeeksAmount('UP')
                                }}
                                disabled={this.props.scheduleWeeksNeeded === 4}
                            >
                                <Icon>chevron_right</Icon>
                            </IconButton>
                        </Typography>
                        {draggableLessonItems}

                    </Grid>
                    <Grid item xs={9}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sunday</TableCell>
                                    <TableCell>Monday</TableCell>
                                    <TableCell>Tuesday</TableCell>
                                    <TableCell>Wednesday</TableCell>
                                    <TableCell>Thursday</TableCell>
                                    <TableCell>Friday</TableCell>
                                    <TableCell>Saturday</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {weekRows}
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateWeeksAmount: Actions.changeScheduleWeeksNeeded,
        dropItemToDay: Actions.dropItemToDay,
    }, dispatch);
}

function mapStateToProps({ moduleApp }) {
    return {

    }
}

// export default DragDropContext(HTML5Backend)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ModuleSchedule))));
export default (withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ModuleSchedule))));


// WEBPACK FOOTER //
// src/main/content/module/ModuleSchedule.js